/**
 * 画布编辑 UI 壳：组装 CanvasDesigner + ImagePanel，持久化由路由页通过 props 处理。
 */
import { toast } from '@heroui/react';
import { CanvasDesigner } from '@/components/canvas/CanvasDesigner';
import { ImagePanel } from './components/ImagePanel';
import { useUploadMediaImage } from './hooks/useUploadMediaImage';
import type { CanvasEditorContainerProps } from './types';

export default function CanvasEditorContainer({
  mode,
  initialDocument,
  initialPageSize,
  readonly = false,
  autoEnterFullscreen = false,
  playConfig = null,
  fileName = '',
  editorKey,
  onDocumentChange,
  onRequestSave,
  onRequestClose,
  onRenameFile,
}: CanvasEditorContainerProps) {
  const { uploadImage } = useUploadMediaImage();

  return (
    <CanvasDesigner
      key={editorKey ?? (initialDocument ? 'doc' : initialPageSize ? 'new' : 'empty')}
      mode={mode}
      initialDocument={initialDocument}
      initialPageSize={!initialDocument ? initialPageSize : undefined}
      readonly={readonly}
      autoEnterFullscreen={autoEnterFullscreen}
      playConfig={playConfig ?? undefined}
      fileName={fileName}
      onChange={onDocumentChange}
      onRequestSave={onRequestSave}
      onRequestClose={onRequestClose}
      onRenameFile={onRenameFile}
      assetAdapters={{ uploadImage }}
      onExportError={(msg) => toast.danger(msg)}
      onExportSuccess={(format) =>
        toast.success(`已导出${format === 'jpeg' ? 'JPG' : 'PNG'}`)
      }
      slots={{ imagePanel: <ImagePanel /> }}
    />
  );
}
